import { KeyboardArrowDown, KeyboardArrowUp, Search } from '@mui/icons-material';
import { SectionProps } from '../../../types/IPlayerSearchFilter';
import LabelText from '../../../ui/LabelText';
import { PlayerSearchFilterStyles } from '../../../styled-components/PlayerComponent.styles';
import { IClubSectionState } from '../../../types/IClubSearch';
import React, { useCallback, useEffect, useState } from 'react';
import RadioButton from '../../../ui/CustomRadioButton';
import { IMinMaxData, ISelectedOption, useClubSearch } from '../../../contexts/ClubSearchContext';
import FilteredDropdown from "../../../ui/FilterDropdown/index";
import { useLoading } from '../../../contexts/LoadingContext';
import BarChart from '../../PlayerLanding/PlayerSearch/BarChart';
import { fetchAllAreaByRegions } from '../../../services/dataService';
import { useNotification } from '../../../contexts/NotificationContext';
import SecondaryButton from '../../../ui/SecondaryButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import TotalAseetsLiabilities from '../../ClubDetail/ClubFinancial/TotalAssetsLiabilities';
import { debounceFunction } from '../../../utils/debounceFunction';
import Info_Icon from "../../../assets/icons/info-icon.svg"
import { min } from 'lodash';
import { debug } from 'console';
import Switch from '../../../ui/CustomSwitch';
import IApiResponse from '../../../types/IApiResponse';
import { fetchData } from '../../../services/api';
import apiUrls from '../../../config/apiUrls';
import handleApiResponse from '../../../utils/handleApiResponse';
import { IRegionAreaModel } from '../../../types/IRegionAreaData';


const wagesSliderData = [
    { wages: 26, number: 5 },
    { wages: 27, number: 20 },
    { wages: 28, number: 10 },
    { wages: 29, number: 25 },
    { wages: 30, number: 30 },
    { wages: 31, number: 35 },
    { wages: 32, number: 50 },
    { wages: 33, number: 70 },
    { wages: 34, number: 40 },
    { wages: 35, number: 60 },
    { wages: 36, number: 30 },
    { wages: 37, number: 25 },
];

const Section: React.FC<SectionProps> = ({ label, isOpen, toggle, children }) => (
    <div className='section'>
        <div className='filters-sub-header' onClick={toggle}>
            <LabelText className='player-search-text'>{label}</LabelText>
            <div className='section-right'>
                {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
        </div>
        {isOpen && children}
    </div>
);

type EfficiencyOption = "any" | "earlyMover" | "average" | "lateMover";
type LeaguePosition = "anyLeague" | "top3" | "top6" | "topHalf" | "midTable" | "bottomHalf" | "relegationZone";

const transferWindowOptions: Record<EfficiencyOption, string> = {
    any: "Any",
    earlyMover: "Early Mover",
    average: "Average",
    lateMover: "Late Mover",
};

const leaguePositionOptions: Record<LeaguePosition, string> = {
    anyLeague: "Any",
    top3: "Top 3",
    top6: "Top 6",
    topHalf: "Top half",
    midTable: "Mid table",
    bottomHalf: "Bottom half",
    relegationZone: "Relegation zone"
}
interface ClubCandidateFilterSectionProps{
    fromClubCandidate? : boolean
}

export type ToggleKey =
  | "affordability"
  | "wageOutlier"
  | "leagueWeighting"
  | "stylisticFit"
  | "systemFit";

const toggleOptions: { key: ToggleKey; label: string }[] = [
    { key: "affordability", label: "Affordability" },
    { key: "wageOutlier", label: "Wage outlier" },
    { key: "leagueWeighting", label: "Adjusted league weighting" },
    { key: "stylisticFit", label: "Stylistic fit uplift" },
    { key: "systemFit", label: "System fit uplift" },
  ];

const ClubCandidateFilterSection = () => {
    const { regionAreaCandidateData, setRegionAreaCandidateData, setClubRegionCandidateValues, clubRegionCandidateValues,
        totalCandidateRevenue, totalCandidateCost, totalCandidateProfitLoss, totalCandidateDebt, totalIntangibleCandidateAssets, retainedCandidateEraning,
         totalCandidateReceivables, receivablesCandidatePercentage,avgSquadCandidateValue,avgCandidateSystemFit,avgCandidatePlayerAge,
        setClubCurrentCandidatePage, setTotalCandidateRevenue, setTotalCandidateCost, setTotalCandidateProfitLoss, setTotalIntangibleCandidateAssets,
         setTotalCandidateDebt, setTotalCandidateReceivables, setReceivablesCandidatePercentage, setIsClubCandidateFilterChange, setRetainedCandidateEraning, 
         debtVsAssetsCandidateRatio, setDebtVsAssetsCandidateRatio , minMaxCandidateData ,setMinMaxCandidateData , setAvgSquadCandidateValue ,
         setAvgCandidateSystemFit,setAvgCandidatePlayerAge,includeCandidateFinancial , setInculdeCandidateFinancial , wholeCandidateSquad , 
         setWholeCandidateSquad , sortClubCandidateOrdering, sortClubCandidateOrderName ,toggles, setToggles} = useClubSearch();

    const { loading, startLoading, stopLoading } = useLoading();
    const { showNotification, hideNotification } = useNotification();
    const [isOpen, setIsOpen] = useState<IClubSectionState>({
        financial: true,
        squad: true,
        transferwindowefficiency: true,
        leagueposition: false,
        clubleague: false
    });
    const [selectedEfficiencyOption, setSelectedEfficiencyOption] = useState<EfficiencyOption>("any");
    const [selectedLeaguePosition, setSelectedLeaguePosition] = useState<LeaguePosition>("anyLeague");
    // const [regionAreaData, setRegionAreaData] = useState<IRegionAreaModel[] | undefined>();
    // const [clubRegionValues, setClubRegionValues] = useState<ISelectedOption[]>([]);
    const [region, setRegion] = useState<ISelectedOption[]>(clubRegionCandidateValues);
    // const [minMaxCandidateData , setMinMaxData] = useState<IMinMaxData | undefined>();
    const [clubTotalRevenue, setClubTotalRevenue] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalRevenue!, max: minMaxCandidateData?.maxTotalRevenue! });
    const [clubTotalCost, setClubTotalCost] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalCost!, max: minMaxCandidateData?.maxTotalCost! });
    const [clubTotalProfitLoss, setClubTotalProfitLoss] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalProfitLoss!, max: minMaxCandidateData?.maxTotalProfitLoss! });
    const [clubTotalDebt, setClubTotalDebt] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalDebt!, max: minMaxCandidateData?.maxTotalDebt! });
    const [clubRetainEarnings, setClubRetainEarnings] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minRetainedEarnings!, max: minMaxCandidateData?.maxRetainedEarnings! });
    const [clubDebtVsAssetsRatio, setClubDebtVsAssetsRatio] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minDebtVsAssetsRatio!, max: minMaxCandidateData?.maxDebtVsAssetsRatio! });
    const [clubTotalIntangibleAssets, setClubTotalIntangibleAssets] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalIntangibleAssets!, max: minMaxCandidateData?.maxTotalIntangibleAssets! });
    const [clubTotalReceivables, setClubTotalReceivables] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minTotalReceivables!, max: minMaxCandidateData?.maxTotalReceivables! });
    const [clubReceivablesPercentage, setClubReceivablesPercentage] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minReceivablesPercentage!, max: minMaxCandidateData?.maxReceivablesPercentage! });
    const [additionalData, setAdditionalData] = useState<string[]>([]);
    const [clubSquadValue, setClubSquadValue] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minAvSquadValue!, max: minMaxCandidateData?.maxAvSquadValue! });
    const [clubSquadPurchaseCost, setClubSquadPurchaseCost] = useState<{ min: number; max: number }>({ min: 0, max: 180000000 });
    const [clubSystemFit, setClubSystemFit] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minAvSystemFit!, max: minMaxCandidateData?.maxAvSystemFit! });
    const [clubPlayerAge, setClubPlayerAge] = useState<{ min: number; max: number }>({ min: minMaxCandidateData?.minAvPlayerAge!, max: minMaxCandidateData?.maxAvPlayerAge! }); 
    const [clubWholeSquad, setClubWholeSquad] = useState<{ min: number; max: number }>({min: minMaxCandidateData?.minPurchaseVsMarketValue!,max: minMaxCandidateData?.maxPurchaseVsMarketValue!});
    // const[filterToggles , setFilterToggles] = useState<{}>()
    const [includeAffordability, setIncludeAffordability] = useState<boolean>(true);
    // const [includeCandidateFinancial  , setInculdeCandidateFinancial] = useState<boolean>(false);
    const [filterToggles, setFilterToggles] = useState<Record<ToggleKey, boolean>>({
        affordability: toggles?.affordability,
        wageOutlier: toggles?.wageOutlier,
        leagueWeighting: toggles?.leagueWeighting,
        stylisticFit: toggles?.stylisticFit,
        systemFit: toggles?.systemFit,
    });

      useEffect(() => {
        const fetchMinMaxData = async () => {
          startLoading();
          const response: IApiResponse<IMinMaxData> = await fetchData(`${apiUrls["GetMinMaxValuesForTeamFilterSearch"]}`);
          handleApiResponse(
            response,
            (minmaxData) => {
              setMinMaxCandidateData(minmaxData);
              stopLoading()
            },
            (error) => {
              console.error("Error fetching Home Team Data:", error);
              stopLoading()
            }
          );
        }
        fetchMinMaxData();
      }, [])

    const toggleSection = useCallback((section: keyof IClubSectionState) => {
        setIsOpen(prevState => ({ ...prevState, [section]: !prevState[section] }));
    }, []);
    const handleSelectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedEfficiencyOption(event.target.value as EfficiencyOption);
    };
    const handleLeaguePositionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedLeaguePosition(event.target.value as LeaguePosition);
    };
    const handleSelectionRegionChange = async (selectedOptions: ISelectedOption[], region: string) => {
        addAdditionalData('Regions');
        setRegion(prevRegion => {
            // Group the roles by region
            const rolesByRegion: Record<string, ISelectedOption[]> = {};
            prevRegion.forEach(area => {
                if (!rolesByRegion[area.region]) {
                    rolesByRegion[area.region] = [];
                }
                rolesByRegion[area.region].push(area);
            });
            // Remove existing options from the same region
            selectedOptions.forEach(newOption => {
                const existingOptions = rolesByRegion[newOption.region];
                if (existingOptions) {
                    existingOptions.forEach(existingOption => {
                        const index = prevRegion.findIndex(area => area.optionId === existingOption.optionId);
                        if (index !== -1) {
                            prevRegion.splice(index, 1);
                        }
                    });
                }
            });
            // Concatenate the unique options with the previous roles
            let updatedRegions = [...prevRegion];
            // If selectedOptions is empty, remove all options for the region
            if (selectedOptions.length === 0) {
                updatedRegions = updatedRegions.filter(area => area.region !== region);
            } else {
                updatedRegions = [...updatedRegions, ...selectedOptions];
            }
            return updatedRegions;
        });
    };
    const addAdditionalData = useCallback((message: string) => {
        if (!additionalData.includes(message)) {
            setAdditionalData(prev => [...prev, message]);
        }
    }, [additionalData]);
    const debouncedAddAdditionalData = debounceFunction(addAdditionalData, 500);

    const handleRevenueValueSliderChange = (min: number, max: number) => {
        setClubTotalRevenue(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Revenue changed');
    }
    const handleCostValueSliderChange = (min: number, max: number) => {
        setClubTotalCost(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Cost changed');
    }
    const handleProfitLossValueSliderChange = (min: number, max: number) => {
        setClubTotalProfitLoss(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Profit/Loss changed');
    }
    const handleDebtValueSliderChange = (min: number, max: number) => {
        setClubTotalDebt(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Debt changed');
    }
    const handleRetainEarnings = (min: number, max: number) => {
        setClubRetainEarnings(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Retained Earnings changed');
    }
    const handleDebtVSAssestRatioSliderChange = (min: number, max: number) => {
        setClubDebtVsAssetsRatio(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Debt VS asset ratio changed');
    }
    const handleIntangibleAssetsSliderChange = (min: number, max: number) => {
        setClubTotalIntangibleAssets(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Intangible assets changed');
    }
    const handleReceivablesSliderChange = (min: number, max: number) => {
        setClubTotalReceivables(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Outstanding receivables changed');
    }
    const handleEstimateReceivablesSliderChange = (min: number, max: number) => {
        setClubReceivablesPercentage(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Outstanding receivables changed');
    }

    const handleAVSquadValues = (min: number, max: number) => {
        setClubSquadValue(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. Player value');
    }

    const handleAVSysytemFit = (min: number, max: number) => {
        setClubSystemFit(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. System fit');
    }

    const handleAVPlayerAge = (min: number, max: number) => {
        setClubPlayerAge(prevRange => ({
            min: min !== undefined ? min : prevRange.min,
            max: max !== undefined ? max : prevRange.max
        }));
        addAdditionalData('Av. player age');
    }

    const handleIncludeFinancial = () =>{
        setInculdeCandidateFinancial(!includeCandidateFinancial)
        addAdditionalData('include financial')
    }

    const handleClubWholeSquad = (min: number, max: number) => {
        setClubWholeSquad({ min: min, max: max });
        addAdditionalData('Purchase Cost / Current Value')
      }

    const generateMessage = () => {
        return (
            <div className='notification-message'>
                <Search />
                <div className='message-content'>
                    <LabelText className='notification-title'>Filters altered</LabelText>
                    <div className='notification-message'>
                        <LabelText className='notification-text'>Changes to: </LabelText>
                        <LabelText className='notification-alter-text'>{additionalData.join(', ')}</LabelText>
                    </div>
                </div>
            </div>
        );
    };

    const handleCancel = useCallback(() => {
        setClubTotalRevenue({ min: totalCandidateRevenue.min, max: totalCandidateRevenue.max });
        setClubTotalCost({ min: totalCandidateCost.min, max: totalCandidateCost.max })
        setClubTotalProfitLoss({ min: totalCandidateProfitLoss.min, max: totalCandidateProfitLoss.max })
        setClubTotalDebt({ min: totalCandidateDebt.min, max: totalCandidateDebt.max });
        setClubTotalIntangibleAssets({ min: totalIntangibleCandidateAssets.min, max: totalIntangibleCandidateAssets.max })
        setClubRetainEarnings({ min: retainedCandidateEraning.min, max: retainedCandidateEraning.max });//----
        setClubTotalReceivables({ min: totalCandidateReceivables.min, max: totalCandidateReceivables.max })
        setClubReceivablesPercentage({ min: receivablesCandidatePercentage.min, max: receivablesCandidatePercentage.max })
        setClubDebtVsAssetsRatio({ min: debtVsAssetsCandidateRatio.min, max: debtVsAssetsCandidateRatio.max })
        setClubSquadValue({ min: avgSquadCandidateValue.min, max: avgSquadCandidateValue.max });
        setClubSystemFit({ min: avgCandidateSystemFit.min, max: avgCandidateSystemFit.max });
        setClubPlayerAge({ min: avgCandidatePlayerAge.min, max: avgCandidatePlayerAge.max });
        setClubWholeSquad({min : wholeCandidateSquad.min , max : wholeCandidateSquad.max})
        setRegion(clubRegionCandidateValues);
        setFilterToggles(toggles)
        
        // setInculdeCandidateFinancial(!includeCandidateFinancial)
        setAdditionalData([]);
        hideNotification();

    }, [
        totalCandidateRevenue, totalCandidateCost, totalCandidateProfitLoss, totalCandidateDebt, totalIntangibleCandidateAssets, totalCandidateReceivables, receivablesCandidatePercentage, hideNotification
        , setAdditionalData, debtVsAssetsCandidateRatio, clubRegionCandidateValues, hideNotification , avgSquadCandidateValue , avgCandidateSystemFit , avgCandidatePlayerAge , includeCandidateFinancial , wholeCandidateSquad , retainedCandidateEraning
    ]);

    const handleRunNewSearch = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        setClubCurrentCandidatePage(1)
        event.preventDefault();
        setTotalCandidateRevenue({ min: clubTotalRevenue.min, max: clubTotalRevenue.max });
        setTotalCandidateCost({ min: clubTotalCost.min, max: clubTotalCost.max })
        setTotalCandidateProfitLoss({ min: clubTotalProfitLoss.min, max: clubTotalProfitLoss.max })
        setTotalCandidateDebt({ min: clubTotalDebt.min, max: clubTotalDebt.max });
        setTotalIntangibleCandidateAssets({ min: clubTotalIntangibleAssets.min, max: clubTotalIntangibleAssets.max });
        setRetainedCandidateEraning({ min: clubRetainEarnings.min, max: clubRetainEarnings.max });//----
        setTotalCandidateReceivables({ min: clubTotalReceivables.min, max: clubTotalReceivables.max })
        setReceivablesCandidatePercentage({ min: clubReceivablesPercentage.min, max: clubReceivablesPercentage.max })
        setDebtVsAssetsCandidateRatio({ min: clubDebtVsAssetsRatio.min, max: clubDebtVsAssetsRatio.max });
        setAvgSquadCandidateValue({ min: clubSquadValue.min, max: clubSquadValue.max });
        setAvgCandidateSystemFit({ min: clubSystemFit.min, max: clubSystemFit.max });
        setAvgCandidatePlayerAge({ min: clubPlayerAge.min, max: clubPlayerAge.max });
        setWholeCandidateSquad({min : clubWholeSquad.min , max : clubWholeSquad.max})
        setClubRegionCandidateValues(region);
        setIsClubCandidateFilterChange(true);
        hideNotification();
        setAdditionalData([]);
        setToggles(filterToggles);

    }, [
        clubTotalRevenue, clubTotalCost, clubTotalProfitLoss, clubTotalDebt, clubTotalIntangibleAssets, clubTotalReceivables,
        clubReceivablesPercentage, hideNotification, clubDebtVsAssetsRatio, region, setAdditionalData , , clubRetainEarnings, clubSquadValue , clubSystemFit , clubPlayerAge , clubWholeSquad , filterToggles
    ]);

    const commonAction = (
        <div className='notification-action'>
            <SecondaryButton label='Cancel' 
            onClick={handleCancel} 
            />
            <PrimaryButton iconType='refresh' label='Run new Search'
                onClick={handleRunNewSearch}
                 />
        </div>
    );

    useEffect(() => {
        const fetchRegionAreaData = async () => {
            // if (regionAreaCandidateData?.length === 0) {
                try {
                    const areaResponse = await fetchAllAreaByRegions();
                    if (areaResponse.isSuccess) {
                        setRegionAreaCandidateData(areaResponse.data);
                    } else {
                        console.error('Failed to fetch area data:', areaResponse);
                    }
                } catch (error) {
                    console.error('Error fetching region area data:', error);
                }
            // }
        };

        fetchRegionAreaData();
    }, []);

    useEffect(() => {
        if (additionalData.length > 0)
            showNotification('FilterNotification', generateMessage(), commonAction);
    }, [clubTotalRevenue, clubTotalCost, clubTotalProfitLoss, clubTotalDebt, clubTotalIntangibleAssets,
        clubTotalReceivables, clubReceivablesPercentage, clubDebtVsAssetsRatio,clubSquadValue,clubSystemFit,clubPlayerAge,includeCandidateFinancial,clubWholeSquad,clubRetainEarnings, additionalData , filterToggles ])

     useEffect(() => {
            setClubTotalRevenue({ min: totalCandidateRevenue.min, max: totalCandidateRevenue.max })
        }, [totalCandidateRevenue])
        useEffect(() => {
            setClubTotalCost({ min: totalCandidateCost.min, max: totalCandidateCost.max })
        }, [totalCandidateCost])
        useEffect(() => {
            setClubTotalProfitLoss({ min: totalCandidateProfitLoss.min, max: totalCandidateProfitLoss.max })
        }, [totalCandidateProfitLoss])
        useEffect(() => {
            setClubTotalDebt({ min: totalCandidateDebt.min, max: totalCandidateDebt.max })
        }, [totalCandidateDebt])
        useEffect(() => {
            setClubRetainEarnings({ min: retainedCandidateEraning.min, max: retainedCandidateEraning.max })
        }, [retainedCandidateEraning])
        useEffect(() => {
            setClubTotalIntangibleAssets({ min: totalIntangibleCandidateAssets.min, max: totalIntangibleCandidateAssets.max })
        }, [totalIntangibleCandidateAssets])
        useEffect(() => {
            setClubTotalReceivables({ min: totalCandidateReceivables.min, max: totalCandidateReceivables.max })
        }, [totalCandidateReceivables])
        useEffect(() => {
            setClubReceivablesPercentage({ min: receivablesCandidatePercentage.min, max: receivablesCandidatePercentage.max })
        }, [receivablesCandidatePercentage])
        useEffect(() => {
            setClubDebtVsAssetsRatio({ min: debtVsAssetsCandidateRatio.min, max: debtVsAssetsCandidateRatio.max })
        }, [debtVsAssetsCandidateRatio])
        useEffect(()=>{
            setClubSquadValue({ min: avgSquadCandidateValue.min, max: avgSquadCandidateValue.max })
        },[avgSquadCandidateValue])
        useEffect(()=>{
            setClubSystemFit({ min: avgCandidateSystemFit.min, max: avgCandidateSystemFit.max })
        },[avgCandidateSystemFit])
        useEffect(()=>{
            setFilterToggles(toggles)
        },[toggles])
        useEffect(()=>{
            setClubPlayerAge({ min: avgCandidatePlayerAge.min, max: avgCandidatePlayerAge.max })
        },[avgCandidatePlayerAge])
        useEffect(()=>{
            setClubWholeSquad({ min: wholeCandidateSquad.min, max: wholeCandidateSquad.max })
        },[wholeCandidateSquad])
        useEffect(() => {
            setRegion(clubRegionCandidateValues);
        }, [clubRegionCandidateValues]);

    // const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    //     event.stopPropagation();
    //     setIncludeAffordability(!includeAffordability);
    //     addAdditionalData('Starts only')
    // };

    const handleSwitchClick = (key: ToggleKey) => {
        setFilterToggles((prev) => ({ ...prev, [key]: !prev[key] }));
        addAdditionalData(key);  
        // console.log("Switch called",key)
    };

    return (
        <div className='player-search-filter-wrapper'>
            <PlayerSearchFilterStyles className='player-search-filter-sections'>
                {/* {includeCandidateFinancial && ( */}
                    {/* {fromClubCandidate &&( */}
                    <div className="candidate-toggle-filter-container">
                        {toggleOptions.map(({ key, label }) => (
                            <div className="toggle-filter-content" key={key}>
                            <LabelText className="primary-cta-text" style={{textAlign:'start'}}>{label}</LabelText>
                            <Switch
                                id={key}
                                toggled={filterToggles[key]}
                                onChange={() => handleSwitchClick(key)}
                                source="Filter"
                                isByComparison={false}
                            />
                            </div>
                        ))}
                    </div>

                    {/* )} */}
                    <Section label='Financial' isOpen={isOpen.financial!} toggle={() => toggleSection('financial')}>
                    <>
                        <div className="financial-search">
                                <div className="financial-search-label" style={{cursor:'pointer',backgroundColor : includeCandidateFinancial ? '#FFF' : '#00D1A8',border : includeCandidateFinancial ? '1px solid #DADADA' : '1px solid #00BE99'}} 
                                onClick={() =>{handleIncludeFinancial()}}>
                                    <LabelText className="secondary-cta-text">{includeCandidateFinancial ? 'Remove financial parameters' : 'Include financial parameters'}</LabelText>
                                </div>
                                <div className="financial-search-container">
                                    <div className="financial-search-content">
                                        <div style={{marginTop:'6px'}}><img src={Info_Icon}/></div>
                                        <div>
                                        <LabelText className="market-value-text">Only clubs who’ve supplied the relevant financial data will surface if financial parameters are included.</LabelText>
                                        <div></div>
                                        <LabelText className="global-search-text">Not all countries require their football clubs to release financial data, and some countries only require a limited set of data is made public.</LabelText>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        {includeCandidateFinancial && (
                            <>
                            <BarChart
                            header="Revenue"
                            data={wagesSliderData}
                            onDataUpdate={handleRevenueValueSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalRevenue!}
                            initialMaxValue={minMaxCandidateData?.maxTotalRevenue!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalRevenue?.min!, clubTotalRevenue?.max!]}
                        />
                        <BarChart
                            header="Costs"
                            data={wagesSliderData}
                            onDataUpdate={handleCostValueSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalCost!}
                            initialMaxValue={minMaxCandidateData?.maxTotalCost!}
                            isFor={"Transfer Value"}
                            // defaultSelectedValue={[clubTotalCost.min, clubTotalCost.max]}
                            defaultSelectedValue={[clubTotalCost?.min!, clubTotalCost?.max!]}
                        />
                        <BarChart
                            header="Profit/loss"
                            data={wagesSliderData}
                            onDataUpdate={handleProfitLossValueSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalProfitLoss!}
                            initialMaxValue={minMaxCandidateData?.maxTotalProfitLoss!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalProfitLoss?.min!, clubTotalProfitLoss?.max!]}
                        />
                        <BarChart
                            header="Debt"
                            data={wagesSliderData}
                            onDataUpdate={handleDebtValueSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalDebt!}
                            initialMaxValue={minMaxCandidateData?.maxTotalDebt!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalDebt.min, clubTotalDebt.max]}
                        />
                        <BarChart
                            // header="Assets/liabilities"
                            header='Retained Earnings'
                            data={wagesSliderData}
                            onDataUpdate={handleRetainEarnings}
                            initialMinValue={minMaxCandidateData?.minRetainedEarnings!}
                            initialMaxValue={minMaxCandidateData?.maxRetainedEarnings!}
                            defaultSelectedValue={[clubRetainEarnings.min, clubRetainEarnings.max]}
                            isFor={"Transfer Value"}
                            // isFor="Assets"
                        />
                        <BarChart
                            header="Debt VS asset ratio"
                            data={wagesSliderData}
                            onDataUpdate={handleDebtVSAssestRatioSliderChange}
                            initialMinValue={minMaxCandidateData?.minDebtVsAssetsRatio!}
                            initialMaxValue={minMaxCandidateData?.maxDebtVsAssetsRatio!}
                            defaultSelectedValue={[clubDebtVsAssetsRatio.min, clubDebtVsAssetsRatio.max]}
                        />
                        <BarChart
                            header="Intangible assets"
                            data={wagesSliderData}
                            onDataUpdate={handleIntangibleAssetsSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalIntangibleAssets!}
                            initialMaxValue={minMaxCandidateData?.maxTotalIntangibleAssets!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalIntangibleAssets.min, clubTotalIntangibleAssets.max]}
                        />
                        <BarChart
                            header="Outstanding receivables"
                            data={wagesSliderData}
                            onDataUpdate={handleReceivablesSliderChange}
                            initialMinValue={minMaxCandidateData?.minTotalReceivables!}
                            initialMaxValue={minMaxCandidateData?.maxTotalReceivables!}
                            isFor={"Transfer Value"}
                            defaultSelectedValue={[clubTotalReceivables.min, clubTotalReceivables.max]}
                        />
                        <BarChart
                            header="Players Receivables % of Total Revenue"
                            data={wagesSliderData}
                            onDataUpdate={handleEstimateReceivablesSliderChange}
                            initialMinValue={minMaxCandidateData?.minReceivablesPercentage!}
                            initialMaxValue={minMaxCandidateData?.maxReceivablesPercentage!}
                            defaultSelectedValue={[clubReceivablesPercentage.min, clubReceivablesPercentage.max]}
                        />
                            
                            </>
                        )}
                        
                    </>
                    </Section>
                {/* )} */}
               
                <Section label='Squad' isOpen={isOpen.squad!} toggle={() => toggleSection('squad')}>
                    <>
                        <BarChart
                            header="Av. Player value"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVSquadValues}
                            initialMinValue={minMaxCandidateData?.minAvSquadValue!}
                            initialMaxValue={minMaxCandidateData?.maxAvSquadValue!}
                            defaultSelectedValue={[clubSquadValue.min, clubSquadValue.max]}
                            isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        />
                        {/* <BarChart
                            header="squad purchase cost / current value"
                            togglelabel={squadPurchaseCost}
                            data={wagesSliderData}
                            onDataUpdate={handleWagesValueSliderChange}
                            initialMinValue={0}
                            initialMaxValue={180000000}
                            defaultSelectedValue={selectedLabel === "1" ? [WagesPW.min, WagesPW.max] : [WagesPA.min, WagesPA.max]}
                            isFor={"Transfer Value"}
                            onChange={handleOnWagesToggleChange}
                            selectedLabel={selectedLabel}
                        /> */}
                         <BarChart
                                    header="Purchase Cost / Current Value"
                                    data={wagesSliderData}
                                    onDataUpdate={handleClubWholeSquad}
                                    initialMinValue={minMaxCandidateData?.minPurchaseVsMarketValue!}
                                    initialMaxValue={minMaxCandidateData?.maxPurchaseVsMarketValue!}
                                    defaultSelectedValue={[clubWholeSquad.min, clubWholeSquad.max]}
                                  />
                        <BarChart
                            header="Av. System fit"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVSysytemFit}
                            initialMinValue={minMaxCandidateData?.minAvSystemFit!}
                            initialMaxValue={minMaxCandidateData?.maxAvSystemFit!}
                            defaultSelectedValue={[clubSystemFit.min, clubSystemFit.max]}
                           // isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        />

                        <BarChart
                            header="Av. player age"
                            //togglelabel={valuelabel}
                            data={wagesSliderData}
                            onDataUpdate={handleAVPlayerAge}
                            initialMinValue={minMaxCandidateData?.minAvPlayerAge!}
                            initialMaxValue={minMaxCandidateData?.maxAvPlayerAge!}
                            defaultSelectedValue={[clubPlayerAge.min, clubPlayerAge.max]}
                            //isFor={"Transfer Value"}
                            //onChange={handleOnWagesToggleChange}
                        /> 

                    </>
                </Section>
                {/* <Section label='Transfer window efficiency' isOpen={isOpen.transferwindowefficiency!} toggle={() => toggleSection('transferwindowefficiency')}>
                    {Object.entries(transferWindowOptions).map(([key, label]) => (
                        <div className="efficiency-options-wrapper">
                            <RadioButton
                                key={key}
                                label={label}
                                name={key}
                                value={key}
                                checked={selectedEfficiencyOption === key}
                                onChange={handleSelectionChange}
                            />
                        </div>
                    ))}
                </Section>
                <Section label='League position' isOpen={isOpen.leagueposition!} toggle={() => toggleSection('leagueposition')}>
                    {Object.entries(leaguePositionOptions).map(([key, label]) => (
                        <div className="efficiency-options-wrapper">
                            <RadioButton
                                key={key}
                                label={label}
                                name={key}
                                value={key}
                                checked={selectedLeaguePosition === key}
                                onChange={handleLeaguePositionChange}
                            />
                        </div>
                    ))}
                </Section> */}
                <Section label='Club league' isOpen={isOpen.clubleague!} toggle={() => toggleSection('clubleague')}>
                    {regionAreaCandidateData?.map((regionItem) => (
                        <FilteredDropdown
                            key={regionItem.region}
                            region={regionItem.region}
                            options={regionItem.areas}
                            type={regionItem.region}
                            onChange={handleSelectionRegionChange}
                            defaultSelectedOptions={region
                                .filter(item => item.region === regionItem.region)
                                .map(item => item.optionId)}
                            includeAll={true}
                            displayAsDropdown={true}
                        />
                    ))}
                </Section>

            </PlayerSearchFilterStyles>
        </div >
    )
}
export default ClubCandidateFilterSection;